import type { RouteLocationNormalized } from 'vue-router';

export const defaultLayoutComponents = {
	appbar: () => import('~/components/shared/app-bar/app-bar.vue'),
	nav: () => import('~/components/shared/app-navigation/app-navigation.vue')
};

export const defaultLayoutProps = {
	appbar: (route: RouteLocationNormalized) => ({ isCollapsed: route.params?.isCollapsed }),
	nav: (route: RouteLocationNormalized) => ({ isCollapsed: route.params?.isCollapsed })
};

export const settingsLayoutComponents = {
	appbar: () => import('~/components/shared/app-bar/app-settings-bar.vue'),
	nav: () => import('~/components/shared/app-navigation/app-settings-navigation.vue')
};

export const settingsLayoutProps = {
	appbar: (route: RouteLocationNormalized) => ({}),
	nav: (route: RouteLocationNormalized) => ({})
};
